import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { useFields, usePageMessages } from 'apps/auth/hooks/selectors';
import { GTRequestMultiScreenService } from 'apps/auth/services/GTRequestMultiScreenService';

import { REQUEST_ADDITIONAL_FIELDS } from './RequestConstants';
import InputAutoDetect from '../form/InputAutoDetect';

const ToFields = (props) => {
    const { requestAdditionalFieldsTitle, requestAdditionalFieldsSubTitle } = usePageMessages();
    const fields = useFields(props.formName);
    const visibleFields = useMemo(() => GTRequestMultiScreenService.getVisibleFields(fields, REQUEST_ADDITIONAL_FIELDS), [fields]);

    return (
        <>
            <HeaderPanel title={requestAdditionalFieldsTitle} subtitle={requestAdditionalFieldsSubTitle} />
            <fieldset>
                {visibleFields.map((field) => {
                    return (
                        <fieldset key={field.name}>
                            <InputAutoDetect formName={props.formName} field={field} />
                        </fieldset>
                    );
                })}
            </fieldset>
        </>
    );
};
ToFields.propsType = {
    formName: PropTypes.string.isRequired,
};
export default ToFields;
